import axios from 'axios';
import moment from 'moment-timezone'


export default {
  listPurchaseOrders(params, orderBy, direction){ //DEPRECATED

      if(orderBy!=null){
        params['orderBy'] = orderBy;
      }
      if(direction!=null){
        params['direction'] = direction;
      }

			return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/purchase-orders", {params:params})
        .then(response=>{
          return response.data;
        })
  },
  fetchPurchaseOrders(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/purchase-orders", {params:params})
      .then(response=>{
        return response.data;
      })
  },
  getPurchaseOrder(poId){
			return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/purchase-orders/"+poId)
        .then(response=>{
          return response.data;
        })
  },
  postPurchaseOrder(purchaseOrder){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/purchase-orders",purchaseOrder)
      .then(response=>{
        return response.data.id;
      })
  },
  putPurchaseOrder(purchaseOrder){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/purchase-orders/"+purchaseOrder.id,purchaseOrder)
      .then(response=>{
        return response.data;
      })
  },
  generatePurchaseOrderNumber(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/purchase-orders/number")
      .then(response=>{
        return response.data.purchase_order_number;
      })
  },
  deletePurchaseOrder(purchaseOrderId){
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/purchase-orders/"+purchaseOrderId)
      .then(response=>{
        return response.data;
      })
  }

}
